export default __webpack_public_path__ + "static/media/sprite_icon16v14.c0250725.png";